import { createContext } from 'react';
import { RtcInput } from '../util/input/rtc';

export const RtcInputContext = createContext<{input?: RtcInput}>({});